<template>
  <v-menu
    v-model="isMenuOpen"
    location="bottom end"
  >
    <template #activator="{ props }">
      <app-button
        class="qa-attachments__menu-btn"
        type="icon"
        size="small"
        v-bind="props"
        @click.stop
        data-locator="qa-question-attachment-menu-button"
      >
        <app-material-icon name="more_horiz" />
      </app-button>
    </template>

    <v-list data-locator="qa-question-attachment-menu">
      <app-dropdown-button-item
        :label="$t('project.question-answer.QuestionAnswerItemAttachments.preview')"
        icon="visibility"
        data-locator="qa-question-attachment-preview-menu-item"
        @click.stop="onOpenDocument"
      />

      <app-dropdown-button-item
        v-if="document.canResume"
        :label="$t('project.question-answer.QuestionAnswerItemAttachments.summary')"
        data-locator="qa-question-attachment-summary-menu-item"
        @click.stop="onSummarizeDocument"
      >
        <template #icon>
          <v-img
            src="@/assets/img/ai_assistant_ico.svg"
            alt="AI assistant icon"
          />
        </template>
      </app-dropdown-button-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import { openFileViewer } from '@/common/utils/files'

export default {
  name: 'QuestionAnswerItemAttachmentsMenu',
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      isMenuOpen: false,
    }
  },
  computed: {
    ...mapGetters('room', ['roomMnemo']),
  },
  methods: {
    ...mapMutations('documentsAISummary', ['SET_DOCUMENT_TO_SUMMARIZE_WITH_AI']),
    onOpenDocument() {
      this.closeMenu()
      openFileViewer(this.roomMnemo, this.document.id)
    },
    onSummarizeDocument () {
      this.closeMenu()
      this.SET_DOCUMENT_TO_SUMMARIZE_WITH_AI(this.document)
    },
    closeMenu () {
      this.isMenuOpen = false
    },
  },
}
</script>
